/*-----background-----*/ export const ColorOne = "#111a2b";
/*-----main text-----*/ export const ColorTwo = "#ffffff";
/*-----card bg-----*/ export const ColorThree = "rgb(35 45 60 / 40%)";
/*-----card title-----*/ export const ColorFour = "rgb(37, 45, 61)";
/*-----slogan-----*/ export const ColorFive = "#B4C9F2";
/*-----balance bg-----*/ export const ColorSix = "#111a2b";
/*-----menu icon bg-----*/ export const ColorSeven = "#4B4B4B";
/*-----orange-----*/ export const ColorEight = "#F39C12";
/*-----Modal bg-----*/ export const ColorNine = " rgba(17, 26, 43, 0.9)";
/*-----Modalinput bg-----*/ export const ColorTen = "rgba(255, 255, 255, 0.1)";
/*-----Mobile main bg-----*/ export const ColorEleven = "#2A364A";
/*-----error-----*/ export const ColorTwelve = "rgb(201, 43, 66)";
/*-----gradient-----*/ export const ColorThirteen =
  "linear-gradient(180deg, #ef5350 0%, #ffaa00 100%)";

export const RadiusOne = "8px";
export const RadiusTwo = "8px";
export const RadiusThree = "8px";

export const ShadowOne =
  "rgb(0 0 0 / 16%) 0px 3px 6px, rgb(0 0 0 / 23%) 0px 3px 6px";
